import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useConfigContext } from '../config';
export * from './item';
var typeDefs = {
  separator: String
};
var defaults = function defaults() {
  return {
    separator: ''
  };
};
export var Breadcrumb = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Breadcrumb, _Component);
  function Breadcrumb() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return Breadcrumb;
}(Component);
Breadcrumb.template = template;
Breadcrumb.typeDefs = typeDefs;
Breadcrumb.defaults = defaults;